import {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {useLocation, useSearchParams} from "react-router-dom";
import associateServices from "../../services";
import {useSelector} from "react-redux";
import Loading from "../../components/loading";
import SvgIcon from "../../components/svg-icon";

const Policy = () => {
    const {activeLanguage} = useSelector(state => state.globalReducer)
    const [policies, setPolicies] = useState([])
    const [loading, setLoading] = useState(true)
    const [content, setContent] = useState('')
    const [activeTab, setActiveTab] = useState("")

    useEffect(() => {
        if (activeLanguage?.key)
            associateServices.getPolicies({
                lang: activeLanguage?.key
            }).then(res =>
                setPolicies(res?.data || [])
            )
    }, [activeLanguage?.key])


    useEffect(() => {

        if (policies?.length >= 1 && !activeTab) {
            const tab = searchParams.get('tab')

            if (tab) {
                const theTabMe = policies?.find(ii => ii.path === tab)
                console.log('theTabMe = ',theTabMe)
                setActiveTab(theTabMe)
                setSearchParams({tab: tab})

            } else {
                setActiveTab(policies[0])
                setSearchParams({tab: policies[0].path})
            }
        }
    }, [activeTab, policies])

    const {t} = useTranslation()

    const [searchParams, setSearchParams] = useSearchParams()

    // useEffect(() => {
    //     const tab = searchParams.get('tab')
    //     setActiveTab(policies.find(oo => oo.path === tab))
    // }, [searchParams, location?.pathname])


    useEffect(() => {
        if (activeTab) {
            setLoading(true)
            setContent('')
            associateServices.showPolicy({
                path: activeTab?.path,
                lang: activeLanguage?.key
            }).then(res => {


                setContent(res?.data)
                setLoading(false)

            })
        }
    }, [activeTab, activeLanguage?.key])

    const handleNavigation = (theTab) => {
        setSearchParams({tab: theTab?.path})
        setActiveTab(theTab)
    }
    return (
        <div className="section section--first">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <h1 className="section__title section__title--head">{t('footer.policies.title')}</h1>
                    </div>
                    <div className="col-12">
                        <div className="content">
                            <div className="dropdown content__dropdown">
                                <button
                                    className="dropdown-toggle content__dropdown-toggle"
                                    type="button"
                                    id="dropdownMenuButton"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                >
                                    {activeTab?.title}
                                    <SvgIcon id={'right-down'}/>
                                </button>
                                <ul
                                    className="dropdown-menu content__dropdown-menu"
                                    aria-labelledby="dropdownMenuButton"
                                >
                                    {
                                        policies?.map(policy => (
                                            <li key={policy.path} className="nav-item" role="presentation">
                                                <button
                                                    onClick={e => handleNavigation(policy)}
                                                    className={policy.path === activeTab?.path ? 'active' : ''}
                                                    type="button">
                                                    <SvgIcon id={'arrow-dash'}/>
                                                    {policy.title}
                                                </button>
                                            </li>
                                        ))

                                    }
                                </ul>
                            </div>


                            <div className="content__menu">
                                <ul
                                    className="nav nav-tabs content__nav"
                                    id="content__nav"
                                    role="tablist"
                                >
                                    {
                                        policies?.map(policy => (
                                            <li key={policy.path} className="nav-item" role="presentation">
                                                <button
                                                    onClick={e => handleNavigation(policy)}
                                                    className={policy.path === activeTab?.path ? 'active' : ''}
                                                    type="button">
                                                    <SvgIcon id={'arrow-dash'}/>
                                                    {policy.title}
                                                </button>
                                            </li>
                                        ))

                                    }

                                </ul>
                            </div>


                            <div className="content__main">
                                <div className="tab-content">


                                    <div className="article">

                                        {
                                            loading ? <Loading/> :
                                                <div dangerouslySetInnerHTML={{__html: content}}/>
                                        }

                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )

}

export default Policy
